import { stopSubmit, SubmissionError, initialize, reset, submit, destroy, registerField, unregisterField, change, untouch, setSubmitFailed } from 'redux-form'

import { ShowWarningDispatch, ShowErrorDispatch } from './ShowNotificationActions'
import _ from 'common-tools/LodashHelper'

const ShowWarning = ShowWarningDispatch()
const ShowError = ShowErrorDispatch()

export const formInitValues = (dispatch) => {
  return (formName, data) => {
    dispatch(initialize(formName, _.extend({}, data), false))
  }
}

export const formResetValues = (dispatch) => {
  return (formName) => {
    dispatch(reset(formName))
  }
}

export const formSubmit = (dispatch) => {
  return (formName) => {
    dispatch(submit(formName))
  }
}

export const formDestroy = (dispatch) => {
  return (formName) => {
    dispatch(destroy(formName))
  }
}

export const formRegisterField = (dispatch) => {
  return (formName, fieldName) => {
    dispatch(registerField(formName, fieldName, 'Field'))
  }
}

export const formRegisterFieldArray = (dispatch) => {
  return (formName, fieldName) => {
    dispatch(registerField(formName, fieldName, 'FieldArray'))
  }
}

export const formUnregisterField = (dispatch) => {
  return (formName, fieldName) => {
    dispatch(unregisterField(formName, fieldName))
  }
}

export const formSetFieldValue = (dispatch) => {
  return (formName, fieldName, value) => {
    dispatch(change(formName, fieldName, value))
  }
}

export const formResetFieldStates = (dispatch) => {
  return (formName, fieldNames) => {
    dispatch(untouch(formName, fieldNames))
  }
}

export const formSetValidationFailed = (dispatch) => {
  return (formName, fieldNames) => {
    dispatch(setSubmitFailed(formName, fieldNames))
  }
}

export const formStopSubmit = (dispatch) => {
  return (formName, errors, fieldNames) => {
    dispatch(stopSubmit(formName, errors))
    if (_.isArray(fieldNames)) {
      dispatch(setSubmitFailed(formName, ...fieldNames))
      ShowWarning('Validation Failed!')
    } else {
      const fields = _.keys(errors)
      if (!_.isEmpty(errors)) {
        dispatch(setSubmitFailed(formName, ...fields))
        ShowWarning('Validation Failed!')
      }
    }
  }
}

export const formCheckForSubmissionErrors = (dispatch) => {
  return (error) => {
    if (_.isArray(error) === false) {
      // some other error, just need to throw submission error
      throw new SubmissionError({
        _error: 'Submit Failed!'
      })
    }

    let validationErrors = _.filter(error, { TypeText: 'Rule' })

    if (validationErrors.length > 0) {
      let valMap = {}
      _.each(validationErrors, (ve) => {
        if (ve.FieldName) {
          if (_.has(valMap, ve.FieldName)) {
            _.set(valMap, ve.FieldName, _.join([_.get(valMap, ve.FieldName), ve.Message], ','))
          } else {
            _.set(valMap, ve.FieldName, ve.Message)
          }
        }
      })
      ShowWarning('Validation Failed!')
      throw new SubmissionError(valMap)
    }

    // let otherErrors = _.filter(error, { Type: 1 })

    // if (otherErrors.length > 0) {
    //   throw new SubmissionError({
    //     _error: 'Submit Failed!'
    //   })
    // }
  }
}

export const formShowSubmissionErrors = (dispatch) => {
  return (error) => {
    if (_.isArray(error) === false) {
      ShowError('Unexpected Error Format!, see console log for details')
      console.log(error)
    }

    if (error.length > 0) {
      _.each(error, (ve) => {
        if (ve.TypeText === 'Rule') {
          ShowWarning(`${ve.FieldName}: ${ve.Message}`)
        } else {
          ShowError(ve.Message)
        }
      })
    }
  }
}
